import React, { useState, useEffect } from "react";
import config from "../../Config";
import axios from "axios";
import { Link } from "react-router-dom";
import Spinner from "react-bootstrap/Spinner";
import { useNavigate, useParams } from "react-router-dom";
import { NavLink } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Form } from "react-bootstrap";
import moment from "moment";
import UserGroupDropDown from "../Shared/UserGroupDropDown";
import TransportMenu from "./TransportMenu";
import { scrollToTop } from "../Shared/ScrollOnTop";

function EditBusRoutes(props) {
  const [AccessKey, setAccessKey] = useState(localStorage.getItem("AccessKey"));
  const [UserID, setUserID] = useState(localStorage.getItem("ID"));
  const [MemberType, setMemberType] = useState(
    localStorage.getItem("MemberType")
  );
  const [validated, setValidated] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [hasError, setHasError] = useState(false);
  const [loading, setLoading] = useState(false);
  const [BusRoute, setBusRoute] = useState({});

  let params = useParams();
  const [BusRouteID, setBusRouteID] = useState(params.id);

  let navigate = useNavigate();

  useEffect(() => {
    document.title = "Add/Update Bus Routes";

    const data = {
      AccessKey: AccessKey,
      UserID: UserID,
      MemberType: MemberType,
      ID: BusRouteID,
    };
    //console.log(data);
    var api_config = {
      method: "post",
      url: config.base_url + "Busroute/GetBusRouteByID",
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    axios(api_config)
      .then(function (response) {
        //console.log(response.data);
        if (response.data.status_code == 1) {
          setBusRoute(response.data.BusRoute);
        }

        setLoading(false);
      })
      .catch(function (error) {
        setLoading(false);
        toast.error("Network Error..", {
          position: toast.POSITION.TOP_RIGHT,
        });
      });
  }, []);

  const handleSubmit = (event) => {
    event.preventDefault();
    event.stopPropagation();
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
    } else {
      setLoading(true);
      const data = {
        AccessKey: AccessKey,
        UserID: UserID,
        MemberType: MemberType,
        Root_ID: BusRouteID,
        Root_Code: event.target.txtRootCode.value,
        Area_Name: event.target.txtAreaName.value,
        Root_Details: event.target.txtRootDetails.value,
        PickUp_Fee: event.target.txtPickUpFee.value,
        DropOf_Fee: event.target.txtDropOfFee.value,
        PickDrop_Fee: event.target.txtPickDropFee.value,
        BusNumber: event.target.txtBusNumber.value,
        Zone: event.target.txtZone.value,
        BusDetails: event.target.txtBusDetails.value,
        FuelType: event.target.txtFuelType.value,
        Ownership: event.target.txtBusOwnership.value,
        Root_Name: "",
        Root_Fee: 0,
      };

      //console.log(data);

      var api_config = {
        method: "post",
        url: config.base_url + "Busroute/UpdateBusRoute",
        headers: {
          "Content-Type": "application/json",
        },
        data: data,
      };

      axios(api_config)
        .then(function (response) {
          //console.log(response.data);
          if (response.data.status_code == 1) {
            toast.success(response.data.status_message, {
              position: toast.POSITION.TOP_RIGHT,
            });
          } else {
            toast.error(response.data.status_message, {
              position: toast.POSITION.TOP_RIGHT,
            });
          }

          setLoading(false);
        })
        .catch(function (error) {
          setLoading(false);
          toast.error("Network Error..", {
            position: toast.POSITION.TOP_RIGHT,
          });
        });
    }

    setValidated(true);
  };

  return (
    <>
      <TransportMenu />
      <ToastContainer />
      <div className="page-head">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-6">
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/Dashboard">Dashboard</Link>
                  </li>
                  <li className="breadcrumb-item">
                    {" "}
                    <Link to="/Transport/TransportDashboard">Transport</Link>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Edit Fee Type
                  </li>
                </ol>
              </nav>
              <div className="page-title">Edit Bus Routes</div>
            </div>
            <div className="col-md-6">
              <div className="page-right-actions">
                <Link
                  to="/Transport/ManageBusRoutes"
                  className="button button-white button-icon"
                >
                  Manage Bus Routes
                  <i className="ri-list-check"></i>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="page-content">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-12">
              <div className="card">
                <div className="card-body">
                  <Form
                    noValidate
                    validated={validated}
                    onSubmit={handleSubmit}
                  >
                    <div className="row align-items-center">
                      <div className="col-md-3">
                        <div className="form-group mb-3">
                          <label>Route Code:</label>
                          <input
                            type="text"
                            defaultValue={BusRoute.Root_Code}
                            className="form-control"
                            required
                            name="txtRootCode"
                          />
                        </div>
                      </div>
                      <div className="col-md-3">
                        <div className="form-group mb-3">
                          <label className="">Area Name:</label>
                          <input
                            type="text"
                            defaultValue={BusRoute.Area_Name}
                            className="form-control"
                            required
                            name="txtAreaName"
                          />
                        </div>
                      </div>
                      <div className="col-md-3">
                        <div className="form-group mb-3">
                          <label className="">PickUp Fee:</label>
                          <input
                            type="text"
                            defaultValue={BusRoute.PickUp_Fee}
                            className="form-control"
                            required
                            name="txtPickUpFee"
                          />
                        </div>
                      </div>
                      <div className="col-md-3">
                        <div className="form-group mb-3">
                          <label className="">DropOff Fee:</label>
                          <input
                            type="text"
                            defaultValue={BusRoute.DropOf_Fee}
                            className="form-control"
                            required
                            name="txtDropOfFee"
                          />
                        </div>
                      </div>
                      <div className="col-md-3">
                        <div className="form-group mb-3">
                          <label className="">Pick & Drop Fee:</label>
                          <input
                            type="text"
                            defaultValue={BusRoute.PickDrop_Fee}
                            className="form-control"
                            required
                            name="txtPickDropFee"
                          />
                        </div>
                      </div>
                      <div className="col-md-3">
                        <div className="form-group mb-3">
                          <label className="">Zone:</label>
                          <input
                            type="text"
                            defaultValue={BusRoute.Zone}
                            className="form-control"
                            required
                            name="txtZone"
                          />
                        </div>
                      </div>

                      <div className="col-md-3">
                        <div className="form-group mb-3">
                          <label className="">Bus Number:</label>
                          <input
                            type="text"
                            defaultValue={BusRoute.BusNumber}
                            className="form-control"
                            required
                            name="txtBusNumber"
                          />
                        </div>
                      </div>

                      <div className="col-md-10">
                        <div className="form-group mb-3">
                          <label className="">Route Details</label>
                          <input
                            type="text"
                            defaultValue={BusRoute.Root_Details}
                            className="form-control"
                            required
                            name="txtRootDetails"
                          />
                        </div>
                      </div>
                      <div className="col-md-2">
                        <div className="form-group mb-3">
                          <label className="">Bus Ownership:</label>
                          <input
                            type="text"
                            className="form-control"
                            required
                            name="txtBusOwnership"
                            defaultValue={BusRoute.Ownership}
                          />
                        </div>
                      </div>

                      <div className="col-md-10">
                        <div className="form-group mb-3">
                          <label className="">Bus Details</label>
                          <input
                            type="text"
                            defaultValue={BusRoute.BusDetails}
                            className="form-control"
                            required
                            name="txtBusDetails"
                          />
                        </div>
                      </div>

                      <div className="col-md-2">
                        <div className="form-group mb-3">
                          <label className="">Fuel Type</label>
                          <input
                            type="text"
                            defaultValue={BusRoute.FuelType}
                            className="form-control"
                            required
                            name="txtFuelType"
                          />
                        </div>
                      </div>

                      <div className="col-md-2 mt-md-2 text-end">
                        <div className="form-group ">
                          {loading ? (
                            <Spinner animation="border" role="status"></Spinner>
                          ) : (
                            <button
                              type="submit"
                              value="Save"
                              className="button button-primary w-100 "
                            >
                              SAVE
                            </button>
                          )}
                        </div>
                      </div>
                    </div>
                  </Form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default EditBusRoutes;
